angular.module('core')
  .filter('dateFromTimestamp', ['$filter', function ($filter) {
    return function (input, format) {
      return $filter('date')(new Date(input * 1000), format);
    };
  }]);
